import React from 'react';
import {Linking, Modal, ScrollView, TouchableOpacity, View} from 'react-native';
import {
  MEMBER_SERVICES_PHONE,
  MEMBER_SERVICES_PHONE_DISPLAY,
} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import Text from '../../elements/Text';

import makeStyles from './styles';

const ProductLimitPopup = ({
  title,
  description,
  visible,
  onRequestClose,
  textAlign,
  testID = tID('ProductLimitPopup-Modal-Main'),
  limitReachedItems,
  ...props
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      testID={testID}
      onRequestClose={onRequestClose}
    >
      <View
        testID={tID('ProductLimitPopup-View-Container')}
        style={styles.centeredView}
      >
        <View style={styles.modalView} bounces={false}>
          <ScrollView bounces={false} showsVerticalScrollIndicator={false}>
            <Text
              testID={tID('ProductLimitPopup-Text-Title')}
              variation="Headline4Bold"
              color={colors.textPrimary}
            >
              {title}
            </Text>
            <Text
              testID={tID('ProductLimitPopup-Text-Description')}
              variation="Body1Regular"
              color={colors.textMuted}
              lineHeight={24}
              topMargin={24}
              style={styles.marginBottom24}
            >
              {description}
            </Text>

            <View style={styles.marginHorizontal11}>
              <View style={styles.flexRow}>
                <Text
                  variation="Body1Regular"
                  color={colors.textMuted}
                  lineHeight={24}
                  style={styles.leftTitle}
                >
                  Product
                </Text>
                <Text
                  variation="Body1Regular"
                  color={colors.textMuted}
                  lineHeight={24}
                  style={styles.rightTitle}
                >
                  Available in
                </Text>
              </View>
              {limitReachedItems.map((item, index) => {
                let availableIn = item.dateAvailable.split(' ');
                return (
                  <View key={index} style={styles.rowContainer}>
                    <View style={styles.itemName}>
                      <Text
                        testID={tID(
                          `ProductLimitPopup-Text-ItemTitle${index + 1}`,
                        )}
                        variation="Body1Regular"
                        color={colors.textMuted}
                        lineHeight={24}
                      >
                        {item.title}
                      </Text>
                    </View>
                    <View style={styles.remainingDays}>
                      <Text
                        testID={tID(
                          `ProductLimitPopup-Text-ItemDate1Available${
                            index + 1
                          }`,
                        )}
                        variation="Body1Bold"
                        color={colors.textMuted}
                        lineHeight={24}
                      >
                        {availableIn[0]}{' '}
                        <Text
                          testID={tID(
                            `ProductLimitPopup-Text-ItemDate2Available${
                              index + 1
                            }`,
                          )}
                          variation="Body1Regular"
                          color={colors.textMuted}
                          lineHeight={24}
                        >
                          {availableIn[1]}
                        </Text>
                      </Text>
                    </View>
                  </View>
                );
              })}
            </View>
            <Text
              variation="Text3Regular"
              color={colors.textMuted}
              lineHeight={15}
              topMargin={24}
              style={styles.marginHorizontal11}
            >
              {
                '*The products listed will be removed from your cart. Please review the items in your cart and select Checkout again.'
              }
            </Text>
            <TouchableOpacity
              testID={tID('ProductLimitPopup-Button-CallMemberServices')}
              onPress={() => Linking.openURL(`tel:${MEMBER_SERVICES_PHONE}`)}
              style={styles.marginHorizontal11}
            >
              <Text
                variation="Text3Regular"
                color={colors.textMuted}
                lineHeight={18}
                topMargin={12}
              >
                Need more than your limit allows? Call our Member Services team
                at{' '}
                <Text variation="Text3Regular" color={colors.link}>
                  {MEMBER_SERVICES_PHONE_DISPLAY}
                </Text>{' '}
                to order more items.
              </Text>
            </TouchableOpacity>
            <View
              testID={tID('ProductLimitPopup-View-ChildrenContainer')}
              style={styles.buttonsContainer}
            >
              {props.children}
            </View>
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

export default ProductLimitPopup;
